import {disableTextSelection} from '../../atBrowserUtils'
import $ from 'jquery'
import View from '../../View'

class BaseUserDataSection extends View
{
}

BaseUserDataSection.prototype.init = function( lightBoxEl, changesCallback, validateCallback )
{
    View.prototype.init.call(this)
    this.lightBoxEl = lightBoxEl;
    this.changesCallback = changesCallback;
    this.validateCallback = validateCallback;
};

BaseUserDataSection.prototype.getSectionElement = function(  )
{
    //abstract
};

BaseUserDataSection.prototype.getElementBySubId = function( name )
{
    return document.getElementById( this.lightBoxEl.id + "_" + name );
};

BaseUserDataSection.prototype.cancelAllServerSideChecks = function()
{};

/**
 * @param [notRequireConfirmationOnCopySettings] is needed to confirm copying settings of another user (false by default)
 */
BaseUserDataSection.prototype.changesDetected = function( notRequireConfirmationOnCopySettings )
{
    if( this.changesCallback)
        this.changesCallback( notRequireConfirmationOnCopySettings );
};

BaseUserDataSection.prototype.validationDetected = function ()
{
    if( this.validateCallback )
        this.validateCallback();
};

BaseUserDataSection.prototype.validate = function ()
{
    return true;
};

BaseUserDataSection.prototype.updateUI = function()
{
};

BaseUserDataSection.prototype.hasErrors = function ()
{
    //noinspection LoopStatementThatDoesntLoopJS
    for( var prop in this.errors ) {
        if( this.errors[prop] == true )
            return true;
    }

    return false;
};

BaseUserDataSection.prototype.makeUnselectable = function(element)
{
    $(element).addClass("unselectable");
    disableTextSelection(element);
};

BaseUserDataSection.prototype.getErrorState = function(  )
{
    return null;
};

BaseUserDataSection.prototype.setErrorState = function( errorState )
{

};

export default BaseUserDataSection



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/BaseUserDataSection.js